import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'
import { V2LvdLegislationBriefingStepShell } from './V2LvdLegislationBriefingStepShell'

export function V2LvdApplicabilityStep({
  step,
  index,
}: {
  step: LvdBriefingStep
  index: number
}) {
  return <V2LvdLegislationBriefingStepShell step={step} index={index} />
}
